export class FindPeaksLabelModel {
  /*
          Форматтер для значений по оси x
      */
  xValueFormatter: Function | null = null;

  /*
          Единицы измерения по оси X
      */
  xUnits: string;

  constructor(xUnits: string, xValueFormatter: Function | null = null) {
    this.xUnits = xUnits;
    this.xValueFormatter = xValueFormatter;
  }
}
